/*
 * The texts of the calendar extension, merged into the lib's own through its js/extension.ts.
 */
export default {
	buttons: {
		calendar: {
			feed: 'Subscribe to calendar',
			subscribe: 'Subscribe',
		},
	},
	components: {
		// efCalendar
		calendar: {
			today: 'Today',
			previous: 'Previous',
			next: 'Next',
			empty: 'No entries in this period.',
			toggle_type: 'Show or hide',
			week: 'Week {week}',
			quarter: 'Q{quarter}',
			earlier_show: 'Show one earlier entry | Show {count} earlier entries',
			earlier_hide: 'Hide earlier entries',
			earlier_months_show: 'Show one earlier month | Show {count} earlier months',
			earlier_months_hide: 'Hide earlier months',
			views: {
				month: 'Month',
				year: 'Year',
				list: 'List',
			},
		},
	},
	modals: {
		me: {
			calendar_feed: {
				title: 'Subscribe to calendar',
				text: 'Your dates in your own calendar, kept up to date automatically.',
				apple: 'Apple Calendar',
				apple_hint: 'Mac, iPhone and iPad',
				desktop: 'Outlook',
				desktop_hint: 'Desktop app on Windows',
				app: 'Calendar app',
				app_hint: 'Open on this device',
				google: 'Google Calendar',
				google_hint: 'Also for Android',
				outlook: 'Outlook.com',
				outlook_hint: 'Personal Microsoft account',
				ms365: 'Microsoft 365',
				ms365_hint: 'Work or school account',
				scan: 'Scan with your phone',
				manual: 'Other calendars: add the address manually',
				url: 'Subscription address',
				copy: 'Copy to clipboard',
				copied: 'Address copied',
				other_hint: 'For example GMX, Web.de, Proton or Nextcloud: add the address there as a calendar subscription. On Android, use Google Calendar or the ICSx5 app.',
				secret: 'Treat the address like a password: whoever holds it sees the entries. Do not share it.',
				last_used: 'Last fetched: {date}',
				never_used: 'Never fetched',
				regenerate: 'Create a new address',
				unavailable: 'This application does not provide a calendar subscription.',
			},
		},
	},
	confirms: {
		regenerate_calendar_token: {
			title: 'Create a new address',
			text: 'The current address stops working. Every calendar application that holds it has to be set up again. Continue?',
		},
	},
};
